import { useParams } from '@tanstack/react-router';

const useMediaPlanId = (): number | undefined => {
  const params = useParams({ strict: false });
  return typeof params.id === 'number' ? params.id : undefined;
};

export default useMediaPlanId;
